import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VatConfigurationFormComponent } from './vat-configuration-form.component';
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { SimpleSelectModule } from "libraries/module/formbuilder/fields/simple-select/simple-select.module";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [VatConfigurationFormComponent],
  exports: [
    VatConfigurationFormComponent
  ],
    imports: [
        CommonModule,
        NumberModule,
        SimpleSelectModule,
        ReactiveFormsModule
    ]
})
export class VatConfigurationModule { }
